export var InsuranceStatus;
(function (InsuranceStatus) {
    InsuranceStatus["Insured"] = "INSURED";
    InsuranceStatus["NotInsured"] = "UNINSURED";
    InsuranceStatus["Unknown"] = "UNKOWN";
})(InsuranceStatus || (InsuranceStatus = {}));
export var PrimaryInsuranceHolder;
(function (PrimaryInsuranceHolder) {
    PrimaryInsuranceHolder["Self"] = "Self";
    PrimaryInsuranceHolder["Spouse"] = "Spouse";
    PrimaryInsuranceHolder["Unknown"] = "Unknown";
})(PrimaryInsuranceHolder || (PrimaryInsuranceHolder = {}));
export var RelationshipToPrimaryInsuranceHolder;
(function (RelationshipToPrimaryInsuranceHolder) {
    RelationshipToPrimaryInsuranceHolder["Self"] = "Self";
    RelationshipToPrimaryInsuranceHolder["Spouse"] = "Spouse";
    RelationshipToPrimaryInsuranceHolder["Parent"] = "Parent";
})(RelationshipToPrimaryInsuranceHolder || (RelationshipToPrimaryInsuranceHolder = {}));
